// ─── Design tokens — panel interno (fondo blanco, tipografía cálida) ──────────
export const C = {
  bg:      "#F8F7F5",   // fondo principal — blanco cálido
  s1:      "#FFFFFF",   // superficie 1
  s2:      "#F2F0ED",   // superficie 2
  s3:      "#EAE8E4",   // superficie 3
  border:  "#E2DFD9",   // borde principal
  border2: "#D4D0CA",   // borde secundario
  white:   "#1A1814",   // texto principal (negro sobre blanco)
  off:     "#3D3A35",   // texto secundario
  muted:   "#8A8580",   // texto terciario
  dim:     "#C4C0BA",   // texto muy suave
  green:   "#16A34A",   // éxito
  red:     "#DC2626",   // error
  amber:   "#D97706",   // advertencia
  blue:    "#2563EB",   // acción
  warm:    "#B5906A",   // acento cálido
};

export const F = {
  serif: "'Playfair Display', Georgia, serif",
  sans:  "'Lato', 'Helvetica Neue', Arial, sans-serif",
  mono:  "'IBM Plex Mono', monospace",
};

// ─── Primitivos UI ────────────────────────────────────────────────────────────

export function Label({ children, style={} }) {
  return (
    <div style={{ fontFamily:F.sans, fontSize:9, letterSpacing:2, textTransform:"uppercase", color:C.muted, ...style }}>
      {children}
    </div>
  );
}

export function Rule({ my=16 }) {
  return <div style={{ height:"1px", background:C.border, margin:`${my}px 0` }}/>;
}

export function Spinner() {
  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", padding:40 }}>
      <div style={{ width:20, height:20, border:`2px solid ${C.border}`, borderTopColor:C.warm, borderRadius:"50%", animation:"spin .7s linear infinite" }}/>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}

export function Btn({ children, onClick, variant="ghost", size="md", disabled=false, style={} }) {
  const base = { fontFamily:F.sans, letterSpacing:1.5, textTransform:"uppercase", cursor:disabled?"not-allowed":"pointer", border:"none", display:"inline-flex", alignItems:"center", gap:6, transition:"all .15s", opacity:disabled?.45:1, fontWeight:700 };
  const sz   = size==="sm" ? { padding:"4px 12px", fontSize:8 } : { padding:"8px 18px", fontSize:9 };
  const vr   = variant==="solid"
    ? { background:C.white, color:C.bg,    border:"none" }
    : { background:"transparent", color:C.muted, border:`1px solid ${C.border}` };
  return <button onClick={onClick} disabled={disabled} style={{ ...base, ...sz, ...vr, ...style }}>{children}</button>;
}

export function Input({ label, value, onChange, placeholder="", type="text", style={} }) {
  return (
    <div style={{ marginBottom:14, ...style }}>
      {label && <Label style={{ marginBottom:5 }}>{label}</Label>}
      <input type={type} value={value} onChange={onChange} placeholder={placeholder} style={{
        width:"100%", background:"transparent", border:"none",
        borderBottom:`1px solid ${C.border2}`, color:C.white,
        fontFamily:F.sans, fontSize:13, padding:"6px 0", outline:"none", fontWeight:300,
      }}/>
    </div>
  );
}

export function Select({ label, value, onChange, options=[], style={} }) {
  return (
    <div style={{ marginBottom:14, ...style }}>
      {label && <Label style={{ marginBottom:5 }}>{label}</Label>}
      <select value={value} onChange={onChange} style={{
        width:"100%", background:C.s2, border:`1px solid ${C.border}`, color:C.white,
        fontFamily:F.sans, fontSize:12, padding:"7px 10px", outline:"none", fontWeight:300,
      }}>
        {options.map(o => typeof o==="string" ? <option key={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}

export function KPI({ label, value, sub="", valueColor=null }) {
  return (
    <div style={{ background:C.s1, padding:"16px 18px", border:`1px solid ${C.border}` }}>
      <Label style={{ marginBottom:8 }}>{label}</Label>
      <div style={{ fontFamily:F.mono, fontSize:20, color:valueColor||C.white, lineHeight:1 }}>{value}</div>
      {sub && <div style={{ fontFamily:F.mono, fontSize:9, color:C.muted, marginTop:4 }}>{sub}</div>}
    </div>
  );
}

export function Badge({ children, color="muted" }) {
  const colors = { muted:C.muted, green:C.green, red:C.red, amber:C.amber, blue:C.blue, warm:C.warm };
  return (
    <span style={{ fontFamily:F.mono, fontSize:8, letterSpacing:1.5, color:colors[color]||C.muted, border:`0.5px solid ${colors[color]||C.muted}`, padding:"2px 7px", textTransform:"uppercase" }}>
      {children}
    </span>
  );
}
